import ApiService from "./base";
import { config } from "@/utils/config";
export default class ProductsService extends ApiService {
    constructor(){
        super({
            baseURL: config.apiUrl
        });
    }
    async getAllProducts() {
        const response = await this.get({
            url: '/direct/products'
        });
        return response.data;
    }
    async getAvailableProducts(customerId) {
        // Only add customerId param if it's a non-empty string
        const url = customerId && customerId.trim() ? `/direct/products/available?customerId=${encodeURIComponent(customerId)}` : '/direct/products/available';
        const response = await this.get({
            url
        });
        return response.data;
    }
    async getProductWithUsagePlans(productCode) {
        const response = await this.get({
            url: `/direct/products/${productCode}`
        });
        return response.data;
    }
}
